import { classicFormatMaxTwoDigits } from '@/utils/hooks/format/useFormatNumber';

import { SIZE_50 } from '@/lib/gridElements/size';

// Components
import { LineChart } from '@/components/composite/Charts/LineChart';

export const followersGrowthHistoryConfig = {
    title: 'chart.linkedin.followers_growth',
    margin: { left: -20, right: 10 },
    name: {
        date: 'date',
        value: 'chart.linkedin.follower_growth_name',
        evolution: 'evolution',
        avg: 'chart.linkedin.followers_growth'
    },
    id: 'follower_growth_history',
    color: {
        value: 'blue',
        avg: 'gray'
    },
    valueFormat: classicFormatMaxTwoDigits,
    tooltip: 'analytics:chart.linkedin.tooltip_follower_growth',
    size: SIZE_50,
    type: 'chart',
    element: LineChart
};
